export default __webpack_public_path__ + "swim-safety-branches-light.svg";